import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useT } from '../../i18n';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import s from './Shell.module.css';

const KEY = 'siraj.sidebar.collapsed';

/** Coque de l'application : barre latérale repliable, barre supérieure, contenu. */
export function Shell() {
  const { t } = useT();
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem(KEY) === '1';
    } catch {
      return false;
    }
  });
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => setMobileOpen(false), [location.pathname]);

  const toggleCollapsed = () => {
    setCollapsed((c) => {
      try {
        localStorage.setItem(KEY, c ? '0' : '1');
      } catch {
        /* ignoré */
      }
      return !c;
    });
  };

  return (
    <div className={s.shell} data-collapsed={collapsed || undefined}>
      <a href="#main" className={s.skip}>
        {t('shell.skipToContent')}
      </a>
      <Sidebar collapsed={collapsed} mobileOpen={mobileOpen} onToggleCollapsed={toggleCollapsed} onCloseMobile={() => setMobileOpen(false)} />
      {mobileOpen && <div className={s.scrim} onClick={() => setMobileOpen(false)} aria-hidden="true" />}
      <div className={s.main}>
        <Topbar onOpenMenu={() => setMobileOpen(true)} />
        <main id="main" className={s.content} tabIndex={-1}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
